const VISITSVIEW = {
  listClients: "Lista de clientes",
  loadMasive: "Cargue masivo",
  createClient: "Crear cliente",
  updateClient: "Actualizar cliente",
  FORMCLIENT: {
    names: "Nombres",
    lastName: "Apellidos",
    EMAILContact: "Email de contacto",
    optional: "(Opcional)",
    address: "Dirección",
    selectionTypeForm: "*Seleccione el tipo de formularios que se asignarán:",
    standarMovil: "Standar (aplicativo móvil)",
    botsViky: "Bots (VIKI)",
    selectedForms: "*Seleccione los formularios",
    searchForm: "Buscar formulario...",
    details: "Detalles",
    update: "Actualizar",
    save: "Guardar",
    clean: "Limpiar",
    address: "Dirección",
    messagge1: "Verifique que la estructura de la dirección sea ejemplo: Calle 84 24 - 78, Bogotá",
    client: "Cliente",
    selectedFormsToClient: "Seleccione el/los Formulario(s) para el cliente",
    errorCreateClient: "Error al crear el cliente.",
    updatedClient: "El cliente se ha actualizado.",
    errorUpdatedClient: "Error al actualizar el cliente.",
    message2: "Verifique que la estructura de la dirección sea ejemplo: Calle 84 24 - 78, Bogotá",
    message3: "Seleccione el/los Formulario(s) para el cliente",
    createdClient: "El cliente se ha creado.",
    errorToCreatedClient: "Error al crear el cliente.",
    errorToUpdateClient: "Error al actualizar el cliente."
  },
  LISTCLIENTS: {
    byPage: "por página",
    client: "Cliente",
    email: "Email",
    phone: "Teléfono",
    created: "Registrado",
    state: "Estado",
    actions: "Acciones",
    deleteUser: "Eliminar usuario",
    textConfirm: "Realmente desea eliminar el usuario: {name} {lastname}"
  },
  LOADMASIVE: {
    donwloadFormat: "Descargar formato",
    settingExcel: "Configuración excel",
    selectTypeForm: "*Seleccione el tipo de formularios que se asignarán:",
    standarMovil: "Standar (aplicativo móvil)",
    botsViky: "Bots (VIKI)",
    none: "Ninguno",
    howManyClients: "Cuantos clientes va a registrar?",
    OrderEmail: "Desea solicitar el E-mail?",
    yes: "Sí",
    no: "No",
    searchForm: "Buscar formulario...",
    HEADTABLE: {
      names: "NOMBRES",
      lastNames: "APELLIDOS",
      email: "EMAIL",
      phone: "TELEFONO",
      address: "DIRECCION",
      details: "DETALLE"
    }
  },
  VISITS: {
    listVisits: "Lista de visitas",
    assignVisit: "Asignar visita",
    updateVisit: "Actualizar visita",
    createVisit: "Crear visita",

    searchUsuario: "Buscar usuario...",
    users: "Usuarios",
    searchClient: "Buscar cliente",
    searchVisit: "Buscar visita",
    filter: "Filtro",
    rangeDate: "Rango de fechas",
    selectDateInitial: "Seleccione fecha inicial",
    selectDateEnd: "Seleccione fecha final",
    createFilter: "Crear Filtro",
    assignment: "Asignación",
    messagge1: "Se han asignado la visita.",



    scheduleVisit: "Agendar visita",
    nameVisit: "Nombre de la visita",
    decriptionVisit: "Descripción de la visita",
    visit: "Visita",
    selectVisit: "Seleccione una visita",


    email: "Email:",
    created: "Creado:",
    phone: "Tel.:",
    address: "Dirección",
    assign: "Asignar",

    addressVisit: "Dirección de la visita",
    dateSheduleInitial: "F. programada inicial",
    dateScheduleEnd: "F. programada inicial",
    detail: "Detalle",
    availableFormToVisit: "Formularios disponibles para esta visita",
    reasonToCalcelVisit: "Rasón por la que desea cancelar la visita",
    fieldMinCaracters: "*El campo debe tener mínimo 6 carácteres.",
    accept: "Aceptar",
    cancel: "Cancelar",
    Reschedule: "Reagendar",
    description: "Descripción",
    titleprompt: "Cancelar visita",
    RescheduleTitle: "REAGENDAR",
    reason: "Razón",
    reasonWhy: "Especifique la razon de la cancelación.",
    moreInformation: "más info...",
    _Reschedule: "Reprogramado",
    scheluder: "Agendado"
  }
};

export default { VISITSVIEW };
